// frontend_react/src/services/inventoryReceiptApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const getInventoryReceipts = ({ companyUuid } = {}) =>
  api.get("/inventory/receipts", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createInventoryReceipt = (payload, { companyUuid } = {}) =>
  api.post("/inventory/receipts", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteInventoryReceipt = (receiptUuid, { companyUuid } = {}) =>
  api.delete(`/inventory/receipts/${receiptUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const searchActivityProductsForReceipt = (query, { companyUuid } = {}) =>
  api.get("/activities/products/search", {
    params: { q: query },
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const searchDistributorProductsForReceipt = (query, { companyUuid } = {}) =>
  api.post(
    "/distributor/search",
    {
      query_dis: query,
      status: "",
    },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );